// Multi-page selection and submission for datatables.  This makes use of dataTables.select, but extends it to do our own checkAll manipulation and include named inputs across pages into a form on submit.
//
// Requires: ES6-capable browser
//
// Usage:
//   Your table should have checkboxes contained in a <td> with the rowSelector class.  These will be used to enable/disable row selection.
//
//   To query selected rows,
//
//   After initializing a datatable -
//            var mps = new multipageSelect({
//                table: '[API instance returned by DataTable()]',
//                tableSelector: '[jquery selector string to find the target table]',
//                formSelector: '[jquery selector string to find the form that will receive inputs from selected rows on form submit.  Be sure to use .trigger('submit') so that the onSubmit event is fired!]',
//                checkallSelector: '[jquery selector string to find the checkAll checkbox (within the context of tableSelector)]',
//                clickCallback: [callbackFunction whenever a click occurs.  Will receive context of the event target of the originating click],
//                rowSelectorClass: '[custom rowSelector class.  default="rowSelector"]'.  Place this class on the container element (ie <td>) containing your selection element
//                disableNextSubmitLatch: boolean - disables table gathering for the next submit event
//            });

function multipageSelect(options) {
    var that=this;
    this.tableDt = null;
    this.tableSelector = null;
    this.formSelector = null;
    this.checkallSelector = null;
    this.clickCallback = null;
    this.rowSelectorClass = 'rowSelector';
    this.selectAllOnSubmit = false;
    this.minimumSelectedCount = 0;
    this.disableNextSubmitLatch = false;

    if (options.table) { this.tableDt = options.table; }
    if (options.tableSelector) { this.tableSelector = options.tableSelector; }
    if (options.formSelector) { this.formSelector = options.formSelector; }
    if (options.checkallSelector) { this.checkallSelector = options.checkallSelector; }
    if (options.clickCallback) { this.clickCallback = options.clickCallback; }
    if (options.rowSelectorClass) { this.rowSelectorClass = options.rowSelectorClass; }
    if (options.selectAllOnSubmit) { this.selectAllOnSubmit = options.selectAllOnSubmit; }
    if (options.disableNextSubmitLatch) { this.disableNextSubmitLatch = options.disableNextSubmitLatch; }

    // Radio button-based rowSelectors on a single-select table get pre-configured to not go below 1 selection (once at least one item is selected).
    this.minimumSelectedCount = (that.tableDt.select.style()=='single' && $('.rowSelector input:radio', this.tableSelector).length) ? 1 : 0;
    // If we ever want to expose this through the options object (because we need a selectable radio button list where radio buttons
    // can be completely deselected), uncomment the following line:
    //if (options.minimumSelectedCount) { this.minimumSelectedCount = options.minimumSelectedCount; }

    // Updates "Select all" control in a data table, but only if a checkallSelector is supplied
    this.updateDataTableSelectAllCtrl = function() {
       if (this.rowSelectorClass && this.checkallSelector)  {
           var $table             = $(this.tableSelector);
           var $chkbox_all        = $('tbody td.' + this.rowSelectorClass + ' input:checkbox', $table);
           var $chkbox_checked    = $('tbody td.' + this.rowSelectorClass + ' input:checkbox:checked', $table);
           var $chkbox_select_all  = $(this.checkallSelector, $table);

           if ($chkbox_select_all.length) {
              // If none of the checkboxes are checked
              if($chkbox_checked.length === 0){
                 $chkbox_select_all.prop('checked', false);
                 $chkbox_select_all.prop('indeterminate', false);
              // If all of the checkboxes are checked
              } else if ($chkbox_checked.length === $chkbox_all.length){
                 $chkbox_select_all.prop('checked' ,true);
                 $chkbox_select_all.prop('indeterminate', false);
              // If some of the checkboxes are checked
              } else {
                 $chkbox_select_all.prop('checked' ,this.getCheckedStateForIndeterminate());
                 $chkbox_select_all.prop('indeterminate' ,true);
              }
           }
       }
    };

    /// Determine the checked state to give to a checkbox
    /// with indeterminate state, so that it becomes checked
    /// on click on IE, Chrome and Firefox 5+.
    /// All glory to https://stackoverflow.com/a/19447939
    this.getCheckedStateForIndeterminate = function()
    {
        // Create a unchecked checkbox with indeterminate state
        var test = document.createElement("input");
        test.type = "checkbox";
        test.checked = false;
        test.indeterminate = true;

        // Try to click the checkbox
        var body = document.body;
        body.appendChild(test); // Required to work on FF
        test.click();
        body.removeChild(test); // Required to work on FF

        // Check if the checkbox is now checked and cache the result
        if (test.checked) {
            this.getCheckedStateForIndeterminate = function () { return false; };
            return false;
        } else {
            this.getCheckedStateForIndeterminate = function () { return true; };
            return true;
        }
    };

    this.doClickFollowup = function(e) {
        // update the state of the select all control
        this.updateDataTableSelectAllCtrl();
        if (this.clickCallback) {
            this.clickCallback.call(e.target);
        }
    };

    // prevent the click on a single row that would deselect a row and bring the total selection count below the configured minimum.
    this.preventSingleRowDeselectClick = function(e, $row) {
        if ($row.length && $row instanceof jQuery) {
            $row = $row[0];
        }

        if (that.tableDt.rows({selected: true}).count() <= that.minimumSelectedCount && $.inArray($row, that.tableDt.rows({selected: true}).nodes())>-1) {
            e.stopPropagation();
            return false;
        }
    };

    // Handle click on "Select all" control.  Only select visible rows as part of SelectAll
    if (this.checkallSelector) {
        $(this.checkallSelector, this.tableSelector).on('click.multipageSelect', function(e) {
            var $visibleRows = $(that.tableSelector).find('tbody tr');
            if(e.target.checked) {
                that.tableDt.rows($visibleRows).select();
            } else {
                that.tableDt.rows($visibleRows).deselect();
            }

            that.doClickFollowup(e);

            // Prevent click event from propagating to parent
            e.stopPropagation();
        });
    }

    // clear all selected but non-visible rows whenever something about the table changes (which would trigger a redraw)
    var clearSelection = function(e){
        var selectedRows = that.tableDt.rows({selected: true}).nodes().toArray();
        if (selectedRows.length) {
            var visibleRows = $(that.tableSelector).find('tr').toArray();
            var deselectRows = selectedRows.filter(function(selRow) { return visibleRows.indexOf(selRow) === -1});
            if (deselectRows.length) {
                that.tableDt.rows(deselectRows).deselect();
            }
        }
    };
    // use draw.dt as it is fired after data is updated, instead of page.dt/order.dt/length.dt which are fired pre-data update.
    $(this.tableSelector).on('draw.dt', clearSelection);

    // "pre-[de]select" handler for .rowSelector
    $('.rowSelector', this.tableSelector).on('click', function(e) {
        var $target = $(e.target);
        if ($target.find('input:radio')) {
            return that.preventSingleRowDeselectClick(e, $target.closest('tr'));
        }
    });

    // "pre-[de]select" handler for supported inputs in .rowSelector.
    // This contains a workaround to datatable's default behavior where selecting (highlighting) text will prevent a select/deselect from occuring.  This is not a bug on datatables, just not the behavior we want.
    $('.rowSelector input:checkbox, .rowSelector input:radio', this.tableSelector).on('click', function(e) {
        var $target = $(e.target);
        var isClickPrevented;

        if ($target.has(':radio')) {
            isClickPrevented = that.preventSingleRowDeselectClick(e, $target.closest('tr'));
        }

        if (!isClickPrevented && ($target.has(':radio') || $target.has(':checkbox'))) {
            // work around datatable's default behavior where selecting text will prevent a select/deselect from occuring.  This is not a bug on datatables, just not the behavior we want.
            var oSel = window.getSelection();
            if (oSel && oSel.type=='Range') {
                if ($target.prop('checked')) {
                    that.tableDt.row($target.closest('tr')).select();
                } else {
                    that.tableDt.row($target.closest('tr')).deselect();
                }
            }
            
        }        
        return isClickPrevented;
    });

    this.tableDt.on( 'select.multipageSelect', function( e, dt, type, indexes ) {       
        $.each(indexes, function(idx, obj) {
            var $rowSelectorThing = $(that.tableDt.row(obj).node()).find('input:checkbox, input:radio');
            if ($rowSelectorThing.length>0) { $rowSelectorThing.prop('checked', true); }
        });

        that.doClickFollowup(e);
    });

    this.tableDt.on( 'deselect.multipageSelect', function( e, dt, type, indexes ) {
        $.each(indexes, function(idx, obj) {


            var $rowSelectorThing = $(that.tableDt.row(obj).node()).find('input:checkbox, input:radio');
            if ($rowSelectorThing.length>0) { $rowSelectorThing.prop('checked', false); }
        });

        that.doClickFollowup(e);
    });

    // Handle table draw event
    this.tableDt.on('draw.multipageSelect', function(e) {
        // Update state of "Select all" control
        that.doClickFollowup(e);
    });

    // Handle form submission event
    $(this.formSelector).on('submit', function(e) {
        var timeoutMs = 250;

        // this is a limiter so that if one submit is already in process, it will wait until it finishes before gathering form elements and doing another submit
        if (that.formSelector && !that.disableNextSubmitLatch) {
            // gather all named inputs from selected rows
            var $allInputs;
            if (that.selectAllOnSubmit) {
                $allInputs = $(that.tableDt.rows().nodes()).find('[name]:input');
            } else {
                $allInputs = $(that.tableDt.rows({selected:true}).nodes()).find('[name]:input');
            }
            // find all *visible* elements in the table that is itself contained within the form, and remove them from the inputs that will be manipulated
            if (that.tableSelector && $(that.tableSelector, that.formSelector).length>0) {
                // if the visible form elements aren't spliced out, those elements will jump around the page right before submit happens
                var $visibleInputs = $('tbody tr [name]:input:visible', that.tableSelector);
                $.each($visibleInputs, function(idx, obj) {
                    var arrIdx = $.inArray(obj, $allInputs);
                    if (arrIdx>-1) {
                        $allInputs.splice(arrIdx, 1);
                    }
                });
            }

            // now clone and append all remaining inputs into the form that don't already exist in the form.
            $allInputs.filter(function(idx, el) {return !($(this).parents(that.formSelector).length);})
                      .clone()
                      .addClass('hidden mpsRemoveAfterSubmit')
                      .appendTo(that.formSelector);
            // "hack" to remove added form elements after submit happens - this is trusting that the timeout has gathered everything it needs from DOM for submit before 
            // the timeout expires, and there's no good way to capture this event on a pure browser submit.
            setTimeout(function() {
                $('.mpsRemoveAfterSubmit', that.formSelector).remove();
            }, timeoutMs);
        }

        that.disableNextSubmitLatch = false;
    });
}